export class CompileError extends Error {}
